

 let mouseDown = false,
     dragStartX = 0,
     dragStartY = 0,
     initialRotateX = 0,
     initialRotateY = 0,
     rotateX = 0,
     rotateY = 0;

 function onDragStart(event) {
   dragStartX = event.clientX;
   dragStartY = event.clientY;
   mouseDown = true;
   document.body.classList.add('mousedown');
 }

 function onDragEnd() {
   if (!mouseDown) {
     return;
   } else {
     mouseDown = false;
     initialRotateX = rotateX;
     initialRotateY = rotateY;
     document.body.classList.remove('mousedown');
   }
 }

 function onMouseMove(event) {
   if (!mouseDown) {
     return;
   } else {
     rotateX = initialRotateX + (dragStartY - event.clientY);
     rotateY = initialRotateY - (dragStartX - event.clientX);
     let transformObject = 'rotateX('+rotateX+'deg) rotateY('+rotateY+'deg)';
     document.getElementById('rotationObject').style.WebkitTransform = transformObject;
     document.getElementById('rotationObject').style.msTransform = transformObject;
     document.getElementById('rotationObject').style.transform = transformObject;
   }
 }

 document.getElementById('book').addEventListener('mousedown', onDragStart, false);
 document.addEventListener('mouseup', onDragEnd, false);
 document.addEventListener('mousemove', onMouseMove, false);




 let color = document.querySelector(".product_image_3d").style.backgroundColor;
 let gallery = document.querySelector(".Product__Gallery");

 if(color != undefined){
   let newColor = color.slice(0,-1) + " ,0.2)"
   gallery.style.backgroundColor = newColor;
 }
